import "@cloudscape-design/global-styles/index.css"
import { I18nProvider } from "@cloudscape-design/components/i18n"
import cloudscapeMessages from "@cloudscape-design/components/i18n/messages/all.en"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { loadConfig } from "./config"
import { AuthProvider } from "./contexts/AuthContext"
import { NotificationProvider } from "./contexts/NotificationContext"
import "./index.css"
import { queryClient } from "./lib/queryClient"
import { applyGlobalTheme } from "./theme"

applyGlobalTheme()

loadConfig()
  .then(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        {/* Cloudscape's built-in English labels (operator names, pagination, clear buttons). */}
        <I18nProvider locale="en" messages={[cloudscapeMessages]}>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </AuthProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </BrowserRouter>
        </I18nProvider>
      </React.StrictMode>,
    )
  })
  .catch((err: unknown) => {
    console.error("Config load failed:", err)
    const root = document.getElementById("root")!
    root.innerHTML = `<div style="padding:2rem;font-family:system-ui">
      <h1>Failed to load application</h1>
      <p>Unable to load configuration. Please refresh the page or contact support.</p>
    </div>`
  })
